import React from "react";

const Diamond = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" className="mx-8 inline-block shrink-0 text-gold" fill="currentColor">
    <path d="M6 0l6 6-6 6-6-6 6-6z" />
  </svg>
);

const WORDS = ["Movies", "Music", "People", "History", "Reviews", "Trailers", "Awards", "Festivals", "Locations", "Stories"];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-edge bg-surface/40 py-6" data-testid="marquee">
    <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
      {[0, 1].map((rep) => (
        <div key={rep} className="flex items-center">
          {WORDS.map((w, i) => (
            <span key={`${rep}-${i}`} className="flex items-center">
              <span className="font-display text-3xl italic text-cream/90 md:text-4xl">{w}</span>
              <Diamond />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
